import BaseNode from './BaseNode';
import { fixedNumber } from '../../utils/common';
import { SHAP_TYPE } from '../../enums/index';

/**
* 点node
*/
class CircleNode extends BaseNode {
  constructor(renderProps, funType, rendrenOption) {
    super(renderProps, funType, rendrenOption);
  }

  async init(renderProps = {}, rendrenOption = {}) {
    const stateNode = new Konva.Circle({
      ...rendrenOption || {},
      ...renderProps
    });

    this.stateNode = stateNode; // Konva实例对象
    this.stateNode.__node = this; // 实例对象反向记录Node对象
    this.shapeType = SHAP_TYPE.CIRCLE; // 图形类别 点还是线
    this.renderData = {
      ...this.renderData || {},
      ...renderProps,
    }
  }

  /**
   * 处理移动后的node操作以及renderData更新
   * @param {*} payload 
   */
  handlerMove({ payload }) {
    const { renderData, stateNode } = this;
    const { x, y } = payload;

    stateNode.move(payload);

    this.renderData = {
      ...renderData,
      x: fixedNumber(renderData.x + x),
      y: fixedNumber(renderData.y + y),
    }
  }

  /**
   * 处理定位后的node操作以及renderData更新
   * @param {*} payload 
   */
  handlerPosition({ payload }) {
    const { renderData, stateNode } = this;
    const { x, y } = payload;

    stateNode.position(payload);

    this.renderData = {
      ...renderData,
      x: fixedNumber(x),
      y: fixedNumber(y),
    }
  }

  /**
   * 处理半径
   * @param {*} param0 
   */
  handlerRadius({ payload }) {
    const { renderData, stateNode } = this;
    const { radius } = payload;

    stateNode.radius(radius);

    this.renderData = {
      ...renderData,
      radius
    }
  }

  // 更新最新的数据 但不做node节点操作
  handlerUpdateRenderData(payload = {}) {
    this.renderData = {
      ...this.renderData,
      ...payload
    }
  }

  // 获取保存的renderData 精简字段名
  // 未来可能存在新的复杂字段 目前就 x y 平译
  getSaveRenderData() {
    const {
      x,
      y,
      radius
    } = this.renderData;

    const saveData = {
      x, y
    }

    if (radius) saveData.radius = radius;

    return saveData;
  }

  // 服务端数据转回渲染数据
  getLocalRenderData(serviceRenderData) {
    const {
      x,
      y,
    } = serviceRenderData;

    return {
      x, y
    }

  }
}

export default CircleNode;